import classNames from 'classnames';
import React from 'react';
import Box, { BoxProps } from 'ui-box';
import { minorScale } from '.';
import { Icon } from './Icon';
import { Intents } from './Intents';

export interface ITagProps extends BoxProps<'span'> {
  intent?: Intents;
  small?: boolean;
  onRemove?: (event: React.MouseEvent<SVGSVGElement, MouseEvent>) => void;
}

export const Tag: React.FC<ITagProps> = ({
  intent = 'none',
  small,
  children,
  onRemove,
  ...props
}) => (
  <Box
    is="span"
    {...props}
    className={classNames(props.className, 'tag', small && 'small', intent)}
  >
    {children}
    {onRemove && (
      <Icon
        icon="small-cross"
        onClick={onRemove}
        marginLeft={minorScale(1)}
        cursor="pointer"
      />
    )}
  </Box>
);
